"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DebtorTile_1 = require("./DebtorTile");
var DebtorTilesContainer = function (_a) {
    var debtors = _a.debtors, setDebtor = _a.setDebtor, setSelectedDebtor = _a.setSelectedDebtor, values = _a.values, setFieldValue = _a.setFieldValue, selectedDebtor = _a.selectedDebtor, BOEInterestRate = _a.BOEInterestRate;
    if (debtors.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "debtor_tile_container flex-row-wrap" }, debtors.map(function (debtor) {
        var isSelected = debtor.id === selectedDebtor.id;
        return (React.createElement(DebtorTile_1.default, { key: debtor.id, debtor: debtor, values: values, onClick: function () {
                if (isSelected) {
                    setSelectedDebtor({ id: null });
                    setDebtor(setFieldValue, debtor, values, BOEInterestRate);
                }
                else {
                    // Select debtor
                    setSelectedDebtor(debtor);
                    setDebtor(setFieldValue, debtor, values, BOEInterestRate);
                }
            } }));
    })));
};
exports.default = DebtorTilesContainer;
